import clsx from 'clsx'
import { Text } from 'react-native'

import { Typography } from '@/src/elements/text/Typography'
import { getStrictDiffInDays } from '@/src/general/primitives/dates/dayjs'

import { usePapaStyle } from './usePapaStyle'

const ARRIVAL_DATE = '2026-09-25'

type TPapaTitleProps = {
  isV2?: boolean
}

export const PapaTitle = ({ isV2 }: TPapaTitleProps) => {
  const { showPapaStyle } = usePapaStyle()

  if (!showPapaStyle) return null

  const daysUntilArrival = Math.ceil(getStrictDiffInDays(new Date(), ARRIVAL_DATE))

  const commonClassName = clsx('px-4 pb-4', !isV2 && 'px-6 md:px-9')

  if (daysUntilArrival <= 0)
    return (
      <Typography black size="3xl" className={clsx('text-leonxivfr', commonClassName)}>
        le pape Léon XIV est en France aujourd'hui !
      </Typography>
    )

  return (
    <Text className={commonClassName}>
      <Typography bold black={!isV2} size={isV2 ? 'mdlc' : 'lg'} className="text-leonxivfr">
        {daysUntilArrival === 1 ? 'Demain' : `Dans ${daysUntilArrival} jours`}
        {isV2 ? ', ' : '\n'}
      </Typography>
      <Typography bold className="text-leonxivfr">
        le pape Léon XIV {daysUntilArrival === 0 ? 'est' : 'sera'} en France{' '}
        {daysUntilArrival === 0 ? "aujourd'hui !" : '!'}
      </Typography>
    </Text>
  )
}
